export default __webpack_public_path__ + "assets/capture-1.75c3d7b6.png";